export var circularMod = function(a, b) {
    return (a % b + b) % b;
};
